<section class="flex flex-col" [ngClass]="{'is-device': isDevice}">
  <!-- Tabs -->
  @if (showTabs) {
    <div class="wrapper">
      <ul class="list list-tabs-container">
        @if (!isDevice) {
          <li class="item title">
            <p>{{ title }}:</p>
          </li>
        }
        @for (loc of formattedLoc | keyvalue; track loc) {
          @if ((loc.key !== 'aall' && isDevice) || !isDevice) {
            <li class="item" [ngClass]="{'is-active': filterType === loc.key}">
              <button mat-button type="button" (click)="filterBy(loc.key, true)">{{ types[loc.key] }}</button>
            </li>
          }
        }
        <li class="item flex-grow-1">&nbsp;</li>
      </ul>
    </div>
  }
  <!-- Content -->
  <section class="list-items-container flex justify-between">
    <div class="nav-dropdown-container">
      @if (categories && showCategories) {
        <select name="categories-dropdown" aria-labelledby="categories" (change)="onFilterChange($event)">
          @for (category of categories; track category) {
            <option value="{{ category.value }}">
              {{ category.label }}
            </option>
          }
        </select>
      }
      <div class="nav-container flex flex-col" tabindex="0">
        <nav>
          <ul class="list flex-col">
            @for (item of filtered; track item; let i = $index) {
              <li
                #listItem
                [id]="'item_' + getIdItem(item)"
                class="item"
                [ngClass]="{'is-active': listItem.id === 'item_' + selectedItemId, 'w-full': isDevice}"
                (click)="moveToTarget(item, true)"
              >
                <div class="text-container w-full">
                  <figure>
                    <img [src]="thumbnails[i]" [attr.aria-label]="item.title" />
                  </figure>
                  <div class="info">
                    <div>
                      <p class="pre-title">{{ item.type }}</p>
                      <h3 class="m-0 text-normal font-light">{{ item.title }}</h3>
                    </div>
                    @if (item.status_slug && !item.is_alternative_for) {
                      <ess-icon-status [status]="item.status_slug"></ess-icon-status>
                    }
                    @if (item.is_alternative_for) {
                      <ess-icon-status status="alternative"></ess-icon-status>
                    }
                  </div>
                </div>
              </li>
            }
          </ul>
        </nav>
      </div>
    </div>
    @if (!isDevice) {
      <div class="separator vertical"></div>
    }
    <lib-ess-map
      #mapLoc
      width="100%"
      (clickMarker)="moveToTarget($event)"
      (clickReadMore)="readMoreEvent($event)"
      [height]="isDevice ? '50vh' : '500px'"
      [isUsingForm]="false"
      [selectedType]="filterType"
      [locations]="latLngLocations"
      [places]="locations"
    ></lib-ess-map>
  </section>
</section>
